import React from 'react';
import './CoreValues.css';

function CoreValues() {
  return (
    <section className="core-values">
      <h2>Our Core Values</h2>
      <div className="values-grid">
        <div className="value-item">
          <h3>🔍 Integrity</h3>
          <p>Transparency and trust drive everything we do.</p>
        </div>
        <div className="value-item">
          <h3>💡 Innovation</h3>
          <p>We challenge norms and fuel creative disruption.</p>
        </div>
        <div className="value-item">
          <h3>🌍 Impact</h3>
          <p>We build with purpose — for society, business, and future generations.</p>
        </div>
      </div>
    </section>
  );
}

export default CoreValues;
